<app-navbar></app-navbar>

<div class="contact-header">
    <h1 class="lg mb-3">General Contact</h1>
    <p class="xl mb-2">Have some feedback or a general question?</p>
    <p class="xl">Get in touch with us below 👋!</p>
</div>

<div class="contact-wrapper">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-xl-7 col-lg-8" *ngIf="data">
                <form #submitRequestForm="ngForm" autocomplete="off" [formGroup]="data" (ngSubmit)="submitRequest()">
                    <div class="contact-contents">
                        <div class="icon mb-5">
                            <i class="bi bi-envelope"></i>
                        </div>
                        <div class="mb-3">
                            <label class="form-label bold">Subject</label>
                            <ng-select [clearable]="false" formControlName="subject" [searchable]="false"
                                placeholder="Select your subject">
                                <ng-option [value]="s.description" *ngFor="let s of subjects">{{s.description}}
                                </ng-option>
                            </ng-select>
                        </div>
                        <div class="mb-3">
                            <label class="form-label bold">Name</label>
                            <input type="text" (keyup)="error = ''" formControlName="name"
                                [readonly]="coreService.isLoggedIn()"
                                [class.is-invalid]="data.get('name').hasError('required') && data.get('name').touched"
                                maxlength="60" required class="form-control" placeholder="Ener your name">
                            <p class="input-error"
                                *ngIf="data.get('name').hasError('required') && data.get('name').touched">
                                Full name is required!</p>
                        </div>
                        <div class="mb-3">
                            <label class="form-label bold">Email</label>
                            <input type="text" (keyup)="error = ''" formControlName="email"
                                [readonly]="coreService.isLoggedIn()" placeholder="Ener your email address" required
                                [class.is-invalid]="data.get('email').hasError('required') && data.get('email').touched"
                                class="form-control">
                            <ng-container *ngIf="data.get('email').touched">
                                <p class="input-error" *ngIf="data.get('email').hasError('required')">
                                    Email is required!</p>
                                <p class="input-error" *ngIf="data.get('email').hasError('email')">
                                    Email is invalid!</p>
                            </ng-container>
                        </div>
                        <div class="mb-3">
                            <label class="form-label bold">Message</label>
                            <textarea class="form-control" rows="6" maxlength="1000" (keyup)="error = ''"
                                formControlName="message"
                                [class.is-invalid]="(data.get('message').hasError('required') && data.get('message').touched) || error"
                                placeholder="Your message"></textarea>
                            <ng-container *ngIf="data.get('message').touched">
                                <p class="input-error" *ngIf="data.get('message').hasError('required')">
                                    Message is required!</p>
                            </ng-container>
                            <p class="input-error" *ngIf="error">
                                {{error}}</p>
                        </div>
                        <button type="submit" class="btn btn-secondary btn-block mt-5" [disabled]="processing">
                            <app-inline-loader [hidden]="!processing"></app-inline-loader>
                            <span [hidden]="processing">Send Message</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>